// Detección de tema claro/oscuro del sistema de diseño — fuente única.
// Lee `data-theme` de <html> (el mecanismo del dashboard) y reacciona al toggle.
import { useEffect, useState } from 'react';

export type ThemeMode = 'light' | 'dark';

export function useThemeMode(): ThemeMode {
  const read = (): ThemeMode =>
    (typeof document !== 'undefined' && document.documentElement.getAttribute('data-theme') === 'light')
      ? 'light' : 'dark';
  const [mode, setMode] = useState<ThemeMode>(read);
  useEffect(() => {
    const obs = new MutationObserver(() => setMode(read()));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    setMode(read());
    return () => obs.disconnect();
  }, []);
  return mode;
}
